import { useHierarchicalGroupsMasterdataQuery } from "@/features/masterdata/queries/hierarchical-groups-masterdata-query";
import { HierarchicalGroup } from "@/types/generated/ExperienceMasterDataApi";
import { ExperienceMasterDataItem } from "@/composables/useExperienceMasterDataApi";
import { mapHierarchicalGroupsToMap } from "@/features/masterdata/lib/mapHierarchicalGroupsToMap";

export function useHierarchicalGroupsMasterdata() {
  const query = useHierarchicalGroupsMasterdataQuery();

  const hierarchicalGroups = computed(() => {
    const groups = query.data.value || [];
    return mapHierarchicalGroupsToMap(groups);
  });

  function getHierarchicalGroupsByPremadesList(premadeList: ExperienceMasterDataItem[]) {
    if (!premadeList) {
      return [];
    }

    const uniqueGroups = premadeList
      .map((item) => hierarchicalGroups.value.get(item.hierarchical_group_code ?? ""))
      .filter((group): group is HierarchicalGroup => group !== undefined);
    return Array.from(mapHierarchicalGroupsToMap(uniqueGroups).values());
  }

  return {
    hierarchicalGroups,
    getHierarchicalGroupsByPremadesList,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
